import React from "react";

const NoMatch = () => (
  <div style={{ padding: "20px 0" }}>
    404 Error - Page Not Found
  </div>
);

export default NoMatch;
